/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';

class Inboxes extends CacheEnabledApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'inbox';
  }

  getCampaigns(inboxId) {
    return axios.get(`${this.url}/${inboxId}/campaigns`);
  }

  deleteInboxAvatar(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/avatar`);
  }

  getAgentBot(inboxId) {
    return axios.get(`${this.url}/${inboxId}/agent_bot`);
  }

  setAgentBot(inboxId, botId) {
    return axios.post(`${this.url}/${inboxId}/set_agent_bot`, {
      agent_bot: botId,
    });
  }

  syncTemplates(inboxId) {
    return axios.post(`${this.url}/${inboxId}/sync_templates`);
  }

  recreateEvolutionInstance(inboxId) {
    return axios.post(`${this.url}/${inboxId}/recreate_evolution_instance`);
  }

  recreateWahaInstance(inboxId) {
    return axios.post(`${this.url}/${inboxId}/recreate_waha_instance`);
  }

  connectUazapiInstance(inboxId, payload = {}) {
    return axios.post(
      `${this.url}/${inboxId}/connect_uazapi_instance`,
      payload
    );
  }

  getUazapiInstanceStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/uazapi_instance_status`);
  }

  disconnectUazapiInstance(inboxId) {
    return axios.post(`${this.url}/${inboxId}/disconnect_uazapi_instance`);
  }

  recreateUazapiInstance(inboxId) {
    return axios.post(`${this.url}/${inboxId}/recreate_uazapi_instance`);
  }

  refreshWhatsappCloudStatus(inboxId) {
    return axios.post(`${this.url}/${inboxId}/refresh_whatsapp_cloud_status`);
  }

  migrate(payload) {
    return axios.post(`${this.url}/migrate`, payload);
  }

  migrationStatus(taskId) {
    return axios.get(`${this.url}/migrate_status`, { params: { id: taskId } });
  }
}

export default new Inboxes();
